<app-header></app-header>
<div class="container-fluid">
    <div class="row justify-content-md-center">
        <div class="col-11">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<app-footer></app-footer>